<template>
  <organizationDetails
    :me="me"
    :organizationId="$route.params.organizationId"
  ></organizationDetails>
</template>

<script>
import organizationDetails from "../../components/OrganizationDetails.vue";
export default {
  name: "Organization",
  props: ["me"],
  components: {
    organizationDetails
  },
  data() {
    return {};
  }
};
</script>